import { GUIDToUint8 } from "../encoding/GUIDToUint8"
import type { GUID } from "../types/GUID"
import { UInt8Hash } from "./UInt8Hash"

export async function HMACSha256(
  key: Uint8Array,
  message: Uint8Array
): Promise<GUID> {
  const blockSize = 64 // SHA-256 block size

  // If key is longer than block size, hash it first
  let processedKey = key
  if (key.length > blockSize) {
    const hashedKey = await UInt8Hash([key])
    processedKey = GUIDToUint8(hashedKey)
  }

  // Pad key to block size
  const paddedKey = new Uint8Array(blockSize)
  paddedKey.set(processedKey)

  // Create inner and outer padding
  const ipad = new Uint8Array(blockSize)
  const opad = new Uint8Array(blockSize)

  for (let i = 0; i < blockSize; i++) {
    ipad[i] = paddedKey[i] ^ 0x36
    opad[i] = paddedKey[i] ^ 0x5c
  }

  // Inner hash: hash(ipad || message)
  const innerData = new Uint8Array(ipad.length + message.length)
  innerData.set(ipad)
  innerData.set(message, ipad.length)
  const innerHash = await UInt8Hash([innerData])
  const innerHashBytes = GUIDToUint8(innerHash)

  // Outer hash: hash(opad || innerHash)
  const outerData = new Uint8Array(opad.length + innerHashBytes.length)
  outerData.set(opad)
  outerData.set(innerHashBytes, opad.length)

  return await UInt8Hash([outerData])
}
